import { Avatar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FaEdit, FaEye } from "react-icons/fa";
import { BsTrashFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MuiDataTable from "../../../../Components/MUIDataTable/MUIDataTable";
import Modal from "../../../../Components/SiteModal/SiteModal";
import {
  getCurrentUserTickets,
  individualTicketDeleted,
} from "../../../../Redux/Actions/Tickets";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import moment from "moment";

const MyTickets = ({
  ticketsPage,
  setTicketsPage,
  ticketsRows,
  setTicketsRows,
  tickets,
  ticketsCount,
  onEditTicket,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: employee } = useSelector((state) => state.currentUser);
  const {
    loading: deletedTicketLoading,
    deletedTicket,
    error: deleteError,
  } = useSelector((state) => state.ticketDeleted);
  const [show, setShow] = useState(false);
  const [ticketId, setTicketId] = useState("");

  useEffect(() => {
    if (deletedTicket && deletedTicket.success) {
      successNotify(deletedTicket?.message);
      dispatch({ type: "INDIVISUAL_TICKET_DELETE_RESET" });
      setShow(false);
      dispatch(getCurrentUserTickets(ticketsPage, ticketsRows));
    }
    if (deleteError) {
      errorNotify(deleteError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [deletedTicket, deleteError, dispatch, ticketsPage, ticketsRows]);

  const handleTicketID = (id) => {
    setTicketId(id);
    setShow(true);
  };

  const deleteModal = (
    <Modal
      title="Delete"
      size={"lg"}
      show={show}
      onCloseModal={() => setShow(false)}
    >
      <React.Fragment>
        <p className="modal_Text">Are u sure you want to delete this ticket?</p>
        <div className="modal_decision">
          <button
            className="my-1 bg_red"
            onClick={() => dispatch(individualTicketDeleted(ticketId))}
          >
            {deletedTicketLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Yes"
            )}
          </button>
          <button className="my-1 no_btn" onClick={() => setShow(false)}>
            No
          </button>
        </div>
      </React.Fragment>
    </Modal>
  );

  const ticketsColumn = [
    {
      name: "_id",
      options: {
        display: false,
      },
    },
    {
      name: "assignBy",
      label: "Assign By",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar src={value?.profile_picture[0]?.fileName} />
              <Typography sx={{ pl: 1 }} className="fs-12">
                {value?.full_name}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "assignTo",
      label: "Assign To",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar src={value?.profile_picture[0]?.fileName} />
              <Typography sx={{ pl: 1 }} className="fs-12">
                {value?.full_name}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "subject",
      label: "Subject",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value}
            </Typography>
          );
        },
      },
    },

    {
      name: "last_date",
      label: "Last Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ pl: 1 }} className="fs-12">
              {value ? moment(value).format("DD-MM-YYYY") : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "priority",
      label: "Priority",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              sx={{ pl: 1, textAlign: "center" }}
              className={
                value === "medium"
                  ? "medium_status"
                  : value === "low"
                    ? "low_status"
                    : value === "critical"
                      ? "critical_status"
                      : value === "high"
                        ? "high_status"
                        : null
              }
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },

    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              sx={{ pl: 1, textAlign: "center" }}
              className={
                value === "on-hold"
                  ? "medium_status"
                  : value === "open"
                    ? "high_status"
                    : value === "close"
                      ? "low_status"
                      : null
              }
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const canModify = tableMeta.rowData[6] === "open";

          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                onClick={() =>
                  navigate(
                    `/${
                      employee?.user?.role === "employee"
                        ? "employee"
                        : "manager"
                    }/tickets/${tableMeta.rowData[0]}`,
                    {
                      state: { update: false },
                    },
                  )
                }
              >
                <FaEye />
              </button>
              {canModify && (
                <button
                  className="edit_btn"
                  onClick={() => onEditTicket(tableMeta.rowData[0])}
                >
                  <FaEdit />
                </button>
              )}
              {canModify && (
                <button
                  className="delete_btn"
                  onClick={() => handleTicketID(tableMeta.rowData[0])}
                >
                  <BsTrashFill />
                </button>
              )}
            </div>
          );
        },
      },
    },
  ];

  return (
    <Box className="departmentsTable">
      {deleteModal}
      <MuiDataTable
        title="Departments"
        columns={ticketsColumn}
        data={tickets}
        page={ticketsPage}
        setPage={setTicketsPage}
        rowsPerPage={ticketsRows}
        setRowsPerPage={setTicketsRows}
        count={ticketsCount}
        tableId="my_tickets_table"
      />
    </Box>
  );
};

export default MyTickets;
